// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface ICorrespondenceIdentificationType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class CorrespondenceIdentificationType implements ICorrespondenceIdentificationType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Customer CorrespondenceIdentificationType
	**/
    get Customer(): ICorrespondenceIdentificationType {
        return this.FromId(1);
    }
    /**
		Returns Vehicle CorrespondenceIdentificationType
	**/
    get Vehicle(): ICorrespondenceIdentificationType {
        return this.FromId(2);
    }
    /**
		Returns VehicleOwnership CorrespondenceIdentificationType
	**/
    get VehicleOwnership(): ICorrespondenceIdentificationType {
        return this.FromId(3);
    }
    /**
		Returns Title CorrespondenceIdentificationType
	**/
    get Title(): ICorrespondenceIdentificationType {
        return this.FromId(4);
    }

    /**
        Returns Registration CorrespondenceIdentificationType
    **/
    get Registration(): ICorrespondenceIdentificationType {
        return this.FromId(5);
    }

    /**
        Returns VehiclePermit CorrespondenceIdentificationType
    **/
    get VehiclePermit(): ICorrespondenceIdentificationType {
        return this.FromId(6);
    }

    /**
        Returns BusinessTransactionNumber CorrespondenceIdentificationType
    **/
    get BusinessTransactionNumber(): ICorrespondenceIdentificationType {
        return this.FromId(7);
    }

    /**
        Returns DriverCredentialID CorrespondenceIdentificationType
    **/
    get DriverCredentialID(): ICorrespondenceIdentificationType {
        return this.FromId(8);
    }

    /**
        Returns Case CorrespondenceIdentificationType
    **/
    get Case(): ICorrespondenceIdentificationType {
        return this.FromId(9);
    }

    /**
        Returns ProhibitionCompliance CorrespondenceIdentificationType
    **/
    get ProhibitionCompliance(): ICorrespondenceIdentificationType {
        return this.FromId(10);
    }

    /**
        Returns PlacardID CorrespondenceIdentificationType
    **/
    get PlacardID(): ICorrespondenceIdentificationType {
        return this.FromId(11);
    }

    /**
        Returns FinanceDisbursementRequest CorrespondenceIdentificationType
    **/
    get FinanceDisbursementRequest(): ICorrespondenceIdentificationType {
        return this.FromId(12);
    }

    /**
        Returns WithdrawalNoticeNoHearing CorrespondenceIdentificationType
    **/
    get WithdrawalNoticeNoHearing(): ICorrespondenceIdentificationType {
        return this.FromId(13);
    }

    /**
        Returns WithdrawalNoticeWithHearing CorrespondenceIdentificationType
    **/
    get WithdrawalNoticeWithHearing(): ICorrespondenceIdentificationType {
        return this.FromId(14);
    }

    /**
        Returns WithdrawalNoticeAdministrativeAction CorrespondenceIdentificationType
    **/
    get WithdrawalNoticeAdministrativeAction(): ICorrespondenceIdentificationType {
        return this.FromId(15);
    }

    /**
        Returns NoticeofRestriction CorrespondenceIdentificationType
    **/
    get NoticeofRestriction(): ICorrespondenceIdentificationType {
        return this.FromId(16);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'Customer', displayValue: 'Customer', description: 'Customer', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'Vehicle', displayValue: 'Vehicle', description: 'Vehicle', sortOrder: 1, active: true });
        this._dictionary.add('3', { id: 3, value: 'VehicleOwnership', displayValue: 'VehicleOwnership', description: 'VehicleOwnership', sortOrder: 1, active: true });
        this._dictionary.add('4', { id: 4, value: 'Title', displayValue: 'Title', description: 'Title', sortOrder: 1, active: true });
        this._dictionary.add('5', { id: 5, value: 'Registration', displayValue: 'Registration', description: 'Registration', sortOrder: 1, active: true });
        this._dictionary.add('6', { id: 6, value: 'VehiclePermit', displayValue: 'VehiclePermit', description: 'VehiclePermit', sortOrder: 1, active: true });
        this._dictionary.add('7', { id: 7, value: 'BusinessTransactionNumber', displayValue: 'BusinessTransactionNumber', description: 'BusinessTransactionNumber', sortOrder: 1, active: true });
        this._dictionary.add('8', { id: 8, value: 'DriverCredentialID', displayValue: 'DriverCredentialID', description: 'DriverCredentialID', sortOrder: 1, active: true });
        this._dictionary.add('9', { id: 9, value: 'Case', displayValue: 'Case', description: 'Case', sortOrder: 1, active: true });
        this._dictionary.add('10', { id: 10, value: 'ProhibitionCompliance', displayValue: 'ProhibitionCompliance', description: 'ProhibitionCompliance', sortOrder: 1, active: true });
        this._dictionary.add('11', { id: 11, value: 'PlacardID', displayValue: 'PlacardID', description: 'PlacardID', sortOrder: 1, active: true });
        this._dictionary.add('12', { id: 12, value: 'FinanceDisbursementRequest', displayValue: 'FinanceDisbursementRequest', description: 'FinanceDisbursementRequest', sortOrder: 1, active: true });
        this._dictionary.add('13', { id: 13, value: 'WithdrawalNoticeNoHearing', displayValue: 'WithdrawalNoticeNoHearing', description: 'WithdrawalNoticeNoHearing', sortOrder: 1, active: true });
        this._dictionary.add('14', { id: 14, value: 'WithdrawalNoticeWithHearing', displayValue: 'WithdrawalNoticeWithHearing', description: 'WithdrawalNoticeWithHearing', sortOrder: 1, active: true });
        this._dictionary.add('15', { id: 15, value: 'WithdrawalNoticeAdministrativeAction', displayValue: 'WithdrawalNoticeAdministrativeAction', description: 'WithdrawalNoticeAdministrativeAction', sortOrder: 1, active: true });
        this._dictionary.add('16', { id: 16, value: 'NoticeofRestriction', displayValue: 'NoticeofRestriction', description: 'NoticeofRestriction', sortOrder: 1, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICorrespondenceIdentificationType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICorrespondenceIdentificationType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICorrespondenceIdentificationType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICorrespondenceIdentificationType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): ICorrespondenceIdentificationType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
